import { safeReactLazy } from 'common/helpers/safe.import';

const Dashboard = safeReactLazy(() => import('./Dashboard/Dashboard'));
const Rentals = safeReactLazy(() => import('./Rentals/Rentals'));
const Subscriptions = safeReactLazy(
  () => import('./Subscriptions/Subscriptions'),
);

const AdminPanelCars = safeReactLazy(
  () => import('./AdminPanelCars/AdminPanelCars'),
);
const Customers = safeReactLazy(() => import('./Customers/Customers'));
const Discounts = safeReactLazy(() => import('./Discounts/Discounts'));
const PageContents = safeReactLazy(() => import('./PageContents/PageContents'));
const Settings = safeReactLazy(() => import('./Settings/Settings'));
const CarEditOrAdd = safeReactLazy(() => import('./CarEditOrAdd/CarEditOrAdd'));

export {
  AdminPanelCars,
  Rentals,
  Customers,
  Dashboard,
  CarEditOrAdd,
  Discounts,
  PageContents,
  Subscriptions,
  Settings,
};
